import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setSessionFromAuthResponse } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get('session_id');
    (async () => {
      try {
        const { data } = await axios.post(`${API}/auth/google-session`, { session_id: sessionId });
        setSessionFromAuthResponse(data);
        navigate('/account', { replace: true });
      } catch (e) {
        setError(e.response?.data?.detail || 'Google sign-in failed.');
        setTimeout(() => navigate('/account', { replace: true }), 2500);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0608] flex items-center justify-center" data-testid="auth-callback">
      {error ? (
        <p className="text-red-400 font-body text-sm" data-testid="auth-callback-error">{error}</p>
      ) : (
        <div className="w-10 h-10 border-2 border-[#f5b400] border-t-transparent rounded-full animate-spin" />
      )}
    </div>
  );
};

export default AuthCallback;
